import React, { useState, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Button,
  Grid,
  Popover,
  Input,
  Tab,
  Tabs
} from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'

import Swal from 'sweetalert2'
import moment from 'moment'
// import queryString from 'query-string'

import { TabPanel, NotificationToast } from '../tools'
import { FilterOptions, UserFilters } from '../forms/Filters'

import {
  setFilter,
  setFromLink,
  setFilterModal
} from '../../../redux/actions/select'
import {
  createFilter,
  getUserFilters,
  updateFilter
} from '../../../redux/actions'
import { defaultFilter } from '../../../utils/variables'

import { isEqual, cloneDeep } from 'lodash'
import FilterSubscription from '../forms/Filters/FilterSubscription'
import FastFilterToggle from '../forms/Filters/FastFilterToggle'

const useStyles = makeStyles(theme => ({
  greenText: {
    color: '#97b557'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  backBtn: {
    borderColor: '#8BB84B',
    color: '#8BB84B',
    '&:hover': {
      color: '#588518',
      borderColor: '#588518'
    }
  },
  saveBtn: {
    marginRight: '1rem',
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  saveFilterBtn: {
    borderColor: '#3984F7',
    color: '#3984F7',
    '&:hover': {
      color: '#2469d2',
      borderColor: '#2469d2'
    }
  },
  cancelButton: {
    borderColor: 'grey',
    color: 'grey',
    '&:hover': {
      color: 'black',
      borderColor: 'black'
    }
  },
  tourButton: {
    '&:focus': {
      outline: 'none'
    }
  },
  nameInput: {
    width: '65%',
    height: '75%'
  },
  filterTabs: {
    '& .MuiTabs-scroller': {
      height: '2em'
    }
  },
  activeFilterTab: {
    padding: '0 2em 1em 2em',
    textTransform: 'capitalize',
    fontWeight: '500',
    borderRadius: '5px 5px 0 0',
    backgroundColor: '#86A345',
    color: 'white',
    '&:focus': {
      outline: 'none'
    },
    alignItems: 'center'
  },
  inactiveFilterTab: {
    padding: '0 2em 1em 2em',
    textTransform: 'capitalize',
    fontWeight: '500',
    borderRadius: '5px 5px 0 0',
    backgroundColor: '#E9F0D8',
    color: '#86A345',
    alignItems: 'center'
  }
}))

/**
 * Creates a modal that displays filter information to send to ElasticSearch
 * @param {func} onFilter function called in the parent component when the Filter button is clicked
 * @param {func} onSave function called in the parent component when the Save button is clicked
 * @param {Object} formData stored filter data based on the currently applied filter
 */
const FilterSlideout = props => {
  const { open, fromLink } = props
  const deepDefaultFilter = cloneDeep(defaultFilter)

  const classes = useStyles()
  const dispatch = useDispatch()

  const defaultSubOptions = {
    subEnabled: false,
    subFrequency: 0,
    subFrequencyType: 'W',
    subStartDate: null,
    subSendEmailOn: null,
    subStartTime: null,
    subEndDate: null,
    subEndLimit: 0,
    subFormat: 'PDF'
  }

  const ActiveView = useSelector(state => state.selection.View)
  const UserFiltersList = useSelector(state => state.filters.filters)
  const DefaultView = useSelector(
    state => state.userSettings.general.defaultView
  )

  const [error, setError] = useState(false)
  const [timeError, setTimeError] = useState(false)
  const [onlyFlagged, setFlagged] = useState(false)

  const [filterNameError, setFilterNameError] = useState(false)
  const [saveFilterModalOpen, setSaveFilterModalOpen] = useState(false)
  const [isEditing, setIsEditing] = useState(false)

  const [dateSelectType, setDateSelectType] = useState('range')

  const [val, setVal] = useState([])
  const [stationVal, setStationVal] = useState([])

  // date time display state for inputs
  const [startDate, setStartDate] = useState(null)
  const [startTime, setStartTime] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [endTime, setEndTime] = useState(null)

  const [subOptions, setSubOptions] = useState({ ...defaultSubOptions })
  const [editedSubOptions, setEditedSubOptions] = useState({ ...defaultSubOptions })
  // const [subStartTime, setSubStartTime] = useState(null)

  const [newFormData, setFormData] = useState({
    ...deepDefaultFilter,
    severityMin:
      deepDefaultFilter.severityMin === 0 ? 1 : deepDefaultFilter.severityMin
  })

  const [filterCheckObject, setFilterCheckObject] = useState({})
  // State for storing the ID of the expanded filter accordion on 'My Filters'
  const [openFilter, setOpenFilter] = useState('')

  const FilterFormTypes = {
    FILTER_OPTIONS: 'Filter Options',
    MY_FILTERS: 'My Filters'
  }

  const [filterForm, setFilterForm] = useState(FilterFormTypes.FILTER_OPTIONS)
  const [filterClickType, setFilterClickType] = useState('')

  const defaultFilterEditData = {
    categoriesToAdd: [],
    categoriesToDelete: [],
    usersToAdd: [],
    usersToDelete: [],
    workstationsToAdd: [],
    workstationsToDelete: [],
    statusesToAdd: [],
    statusesToDelete: []
  }

  const [filterEditData, setFilterEditData] = useState(defaultFilterEditData)
  const [subEndSettings, setSubEndSettings] = useState(null)

  useMemo(() => {
    if (
      (Array.isArray(filterEditData.statusesToAdd) && Boolean(filterEditData.statusesToAdd.length))
    ) {
      const flagStatus = Boolean(filterEditData.statusesToAdd.length) && Boolean(filterEditData.statusesToAdd.find(
        (filterInfo) => typeof filterInfo === 'string' && (/Flagged/ig).test(filterInfo)
      ))

      setFlagged(flagStatus)
    }
  }, [filterEditData.statusesToAdd])

  // Subscription filter error checks (why is this like this? error 1 and error 4 are the same???? Error 1 and two can be combined?? - Cat 6/15/23)
  const subErrs = {
    errorOne:
      !subOptions.subFrequency &&
      subOptions.subSendEmailOn === null &&
      subOptions.subFrequencyType === 'W',
    errorTwo: !subOptions.subFrequency && subOptions.subSendEmailOn !== null,
    errorThree:
      parseInt(subOptions.subFrequency) > 0 &&
      subOptions.subSendEmailOn === null &&
      subOptions.subFrequencyType === 'W',
    errorFour:
      !subOptions.subFrequency &&
      subOptions.subSendEmailOn === null &&
      subOptions.subFrequencyType !== 'W'
  }

  // Checks if the subErr object has an error within it
  const subErrCheck = Object.values(subErrs).includes(true)

  // Sub date end type and error check
  const subEndObj = {
    never: 'never',
    on: 'on',
    after: 'after'
  }

  const subDateErrCheck = Boolean(
    subOptions.subEndDate &&
    subEndSettings === subEndObj.on &&
    (moment(subOptions.subStartDate).isSame(subOptions.subEndDate, 'day') ||
      subOptions.subStartDate >= subOptions.subEndDate)
  )

  // Reset state used when editing a filter
  const handleCancelEdit = () => {
    // Reset state for flagged captures if 'flagged' has not been clicked
    setIsEditing(false)
    setFilterClickType('')
    setVal([])
    setStationVal([])
    setFilterCheckObject({})
    setStartDate(null)
    setStartTime(null)
    setEndDate(null)
    setEndTime(null)
    setDateSelectType('range')
    setFormData(deepDefaultFilter)
  }

  // * Confirm Popover * //
  const [confirmAnchorEl, setConfirmAnchorEl] = useState(null)
  const handleConfirmPopover = e => {
    if (e && e.currentTarget) {
      setConfirmAnchorEl(e.currentTarget)
    } else {
      setConfirmAnchorEl(null)
    }
  }
  const handleConfirmPopClose = () => {
    setConfirmAnchorEl(null)

    if (filterClickType === 'Close Modal') {
      setFilterForm(FilterFormTypes.FILTER_OPTIONS)
      dispatch(setFilterModal(false))
      handleCancelEdit()
      setFilterClickType('')
    }

    if (filterClickType === 'Swap Forms') {
      if (filterForm === FilterFormTypes.FILTER_OPTIONS) {
        setFilterForm(FilterFormTypes.MY_FILTERS)
        handleCancelEdit()
        setFilterClickType('')
      } else if (filterForm === FilterFormTypes.MY_FILTERS) {
        setFilterForm(FilterFormTypes.FILTER_OPTIONS)
        handleCancelEdit()
        setFilterClickType('')
      }
    }
  }
  const openConfirmPopover = Boolean(confirmAnchorEl)

  // * Reset Popover * //
  const [resetAnchorEl, setResetAnchorEl] = useState(null)
  const handleResetPopover = e => {
    if (e && e.currentTarget) {
      setResetAnchorEl(e.currentTarget)
    } else {
      setResetAnchorEl(null)
    }
  }
  const handleResetPopClose = () => {
    setResetAnchorEl(null)
  }
  const openResetPopover = Boolean(resetAnchorEl)

  useEffect(() => {
    dispatch(getUserFilters())
  }, [dispatch])

  const toggleFilterModal = e => {
    const event = e
    // Check if editing existing filter and if changes have been made to show alert
    if (isEditing && !isEqual(newFormData, filterCheckObject)) {
      handleConfirmPopover(event)
      setFilterClickType('Close Modal')
    } else {
      setFilterForm(FilterFormTypes.FILTER_OPTIONS)
      dispatch(setFilterModal(false))
      handleCancelEdit()
      setFormData(deepDefaultFilter)
      setOpenFilter('')
    }
  }

  // Swap filter forms between 'Filter Options' and 'My Filters'
  const handleSwapFilterForms = e => {
    const event = e
    if (isEditing && !isEqual(newFormData, filterCheckObject)) {
      handleConfirmPopover(event)
      setFilterClickType('Swap Forms')
    } else if (filterForm === FilterFormTypes.FILTER_OPTIONS) {
      // dispatch(getUserFilters())
      setFilterForm(FilterFormTypes.MY_FILTERS)
      setSubOptions({ ...defaultSubOptions })
      setEditedSubOptions({ ...defaultSubOptions })
      handleCancelEdit()
    } else if (filterForm === FilterFormTypes.MY_FILTERS) {
      setFilterForm(FilterFormTypes.FILTER_OPTIONS)
      setOpenFilter('')
      setSubOptions({ ...defaultSubOptions })
      setEditedSubOptions({ ...defaultSubOptions })
      handleCancelEdit()
    }
  }

  const ConfirmResetToast = async msg => {
    const { value, dismiss } = await Swal.fire({
      title: msg.msg,
      text: msg.txt ? msg.txt : '',
      icon: 'question',
      showCancelButton: true,
      cancelButtonText: 'No',
      cancelButtonColor: '#97b557',
      confirmButtonText: 'Yes'
    })
    if (value) {
      return true
    } else if (dismiss) {
      return false
    }
  }

  // Format timestamps when applying the filter or saving it to My Filters
  const formatDateTime = form => {
    if (form.startDate && form.startDate >= 0) {
      form.startDate = moment(form.startDate._d).format('YYYY-MM-DD')
    } else {
      form.startDate = 0
    }

    if (form.endDate && form.endDate >= 0) {
      form.endDate = moment(form.endDate._d).format('YYYY-MM-DD')
    } else {
      form.endDate = 0
    }

    if (form.startTime && form.startTime >= 0) {
      form.startTime = moment(form.startTime._d).format('YYYY-MM-DD hh:mm:ss a')
    } else {
      form.startTime = 0
    }

    if (form.endTime && form.endTime >= 0) {
      form.endTime = moment(form.endTime._d).format('YYYY-MM-DD hh:mm:ss a')
    } else {
      form.endTime = 0
    }

    if (form.captureAreas.indexOf('Flagged') !== -1) {
      const index = form.captureAreas.indexOf('Flagged')
      form.captureAreas.splice(index, 1)
      // const mappedFlagIDs = flaggedIDs.map(flag => flag.violationID)
      // form.violationIDs = mappedFlagIDs
    }

    if (
      form.startDate !== 0 &&
      form.endDate !== 0 &&
      form.startTime === 0 &&
      form.endTime === 0
    ) {
      /* Date range selected with no timestamps selected */
      // start date timestamp with no start time
      const rangeStart = moment(
        form.startDate +
        ' ' +
        moment()
          .startOf('day')
          .format('hh:mm:ss a'),
        'YYYY-MM-DD hh:mm:ss a'
      )
      form.startDate = moment(rangeStart._i, 'YYYY-MM-DD hh:mm:ss a').valueOf()
      // end date timestamp with no end time
      const rangeEnd = moment(
        form.endDate +
        ' ' +
        moment()
          .endOf('day')
          .format('hh:mm:ss a'),
        'YYYY-MM-DD hh:mm:ss a'
      )
      form.endDate = moment(rangeEnd._i, 'YYYY-MM-DD hh:mm:ss a').valueOf()
    } else if (
      form.startDate !== 0 &&
      form.endDate !== 0 &&
      form.startTime !== 0 &&
      form.endTime !== 0
    ) {
      /* Date range selected with timestamps selected */
      // start date + start time timestamp
      const rangeStart = moment(
        form.startDate +
        ' ' +
        moment()
          .startOf('day')
          .format('hh:mm:ss a'),
        'YYYY-MM-DD hh:mm:ss a'
      )
      form.startDate = moment(rangeStart._i, 'YYYY-MM-DD hh:mm:ss a').valueOf()
      form.startTime = moment(form.startTime, 'YYYY-MM-DD hh:mm:ss a').valueOf()
      // end date + end time timestamp
      const rangeEnd = moment(
        form.endDate +
        ' ' +
        moment()
          .endOf('day')
          .format('hh:mm:ss a'),
        'YYYY-MM-DD hh:mm:ss a'
      )
      form.endDate = moment(rangeEnd._i, 'YYYY-MM-DD hh:mm:ss a').valueOf()
      form.endTime = moment(form.endTime, 'YYYY-MM-DD hh:mm:ss a').valueOf()
    } else if (
      form.startDate !== 0 &&
      form.endDate === 0 &&
      form.startTime === 0 &&
      form.endTime === 0
    ) {
      const start = form.startDate
      /* Single date selected with no timestamps selected */
      // start date + start of day timestamp
      const singleStart = moment(
        start +
        ' ' +
        moment()
          .startOf('day')
          .format('hh:mm:ss a'),
        'YYYY-MM-DD hh:mm:ss a'
      )
      form.startDate = moment(singleStart._i, 'YYYY-MM-DD hh:mm:ss a').valueOf()
      // start date + end of day timestamp
      const singleEnd = moment(
        start +
        ' ' +
        moment()
          .endOf('day')
          .format('hh:mm:ss a'),
        'YYYY-MM-DD hh:mm:ss a'
      )
      form.endDate = moment(singleEnd._i, 'YYYY-MM-DD hh:mm:ss a').valueOf()
    } else if (
      form.startDate !== 0 &&
      form.endDate === 0 &&
      form.startTime !== 0 &&
      form.endTime !== 0
    ) {
      const start = form.startDate
      /* Single date selected with timestamps selected */
      // start date + start of day timestamp
      const singleStart = moment(
        start +
        ' ' +
        moment()
          .startOf('day')
          .format('hh:mm:ss a'),
        'YYYY-MM-DD hh:mm:ss a'
      )
      form.startDate = moment(singleStart._i, 'YYYY-MM-DD hh:mm:ss a').valueOf()
      form.startTime = moment(form.startTime, 'YYYY-MM-DD hh:mm:ss a').valueOf()
      // form.startTime = 0
      // start date + end of day timestamp
      const singleEnd = moment(
        start +
        ' ' +
        moment()
          .endOf('day')
          .format('hh:mm:ss a'),
        'YYYY-MM-DD hh:mm:ss a'
      )
      form.endDate = moment(singleEnd._i, 'YYYY-MM-DD hh:mm:ss a').valueOf()
      form.endTime = moment(form.endTime, 'YYYY-MM-DD hh:mm:ss a').valueOf()
      // form.endTime = 0
    }
  }

  // Save changes when editing a saved filter
  const handleSaveFilterChanges = (form, type) => {
    // let selectedStartTime = 0
    // let selectedEndTime = 0
    // if (form.startTime !== 0 && form.endTime !== 0) {
    //   selectedStartTime = form.startTime; selectedEndTime = form.endTime
    // }

    formatDateTime(form)

    const sourceNum = form.source === 'all' ? 2 : form.source
    const formattedName = form.filterName
      .replace(/[^a-zA-Z0-9-_.: ]/g, '')
      .trim()
    const tempForm = {
      ...filterEditData,
      ...form,
      filterName: formattedName,
      // startTime: selectedStartTime !== 0 ? form.startDate : 0,
      // endTime: selectedEndTime !== 0 ? form.endDate : 0,
      source: sourceNum
    }

    dispatch(
      updateFilter(
        form.filterID,
        tempForm,
        type,
        fireFilterUpdateSuccess,
        fireFilterSaveFailure
      )
    )
  }

  // Set the filterID to open filter accordion and 'My Filters' if not saving and applying
  const fireFilterUpdateSuccess = (filterID, type) => {
    NotificationToast(false, 'Filter Successfully Updated!')
    handleConfirmPopClose()
    // setFilterCheckObject(newFormData)
    dispatch(getUserFilters())
    if (type === 'save') {
      setOpenFilter(filterID)
      setFilterForm(FilterFormTypes.MY_FILTERS)
      setFilterCheckObject(newFormData)
    } else if (type === 'apply') {
      setFilterForm(FilterFormTypes.FILTER_OPTIONS)
      dispatch(setFilterModal(false))
      handleCancelEdit()
      setFormData(deepDefaultFilter)
      setOpenFilter('')

      props.history.push({
        pathname: '/captures',
        search:
          DefaultView === 'L'
            ? '?view=list&page=1&activeCapture=0'
            : DefaultView === 'G'
              ? '?view=grid&page=1&activeCaptures=[]'
              : '?view=single&capture=1'
      })
      // setFilterCheckObject(newFormData)
    } else {
      setOpenFilter('')
      setFilterForm(FilterFormTypes.FILTER_OPTIONS)
      setFilterCheckObject(newFormData)
    }
  }

  // Apply currently selected filter options and save changes if editing already saved filter
  const handleApply = async (e, form) => {
    e.preventDefault()

    // The Apply button needs to currently only sort a filter, but this may change when this becomes a report filter
    if (dateSelectType === 'range') {
      if (
        (form.startDate && !form.endDate) ||
        (!form.startDate && form.endDate)
      ) {
        setError(true)
      }
    }

    if (!form.endTime && form.startTime) {
      setTimeError(true)
    } else {
      setTimeError(false)
      setError(false)

      form.usernames = val
      form.workstations = stationVal

      formatDateTime(form)

      form.refresh = true

      if (fromLink && onlyFlagged === true) {
        const confirmReset = await ConfirmResetToast({
          msg: 'This filter will return you to all Captures.',
          txt:
            'If you wish to continue, say yes. If not, please select no and choose another filter.'
        })
        if (confirmReset) {
          form.violationIDs = []
          form.includeViolationIDs = []
          dispatch(setFilter(form))

          props.history.push({
            pathname: '/captures',
            search:
              DefaultView === 'L'
                ? '?view=list&page=1&activeCapture=0'
                : DefaultView === 'G'
                  ? '?view=grid&page=1&activeCaptures=[]'
                  : '?view=single&capture=1'
          })
          dispatch(setFromLink(false))
          toggleFilterModal()
        }
      } else {
        const flaggedIncluded = form.statusesToAdd.includes('Flagged')

        const flagCheck = (() => {
          if (
            (onlyFlagged || flaggedIncluded) && Array.isArray(form.captureAreas) && !form.captureAreas.find(
              (filterInfo) => typeof filterInfo === 'string' && (/Flagged/ig).test(filterInfo)
            )
          ) {
            return { captureAreas: ['Flagged', ...form.captureAreas] }
          }
          return {}
        })()

        dispatch(
          setFilter({
            ...form,
            ...flagCheck,
            fastFilterID: form.isFastFilter ? form.filterID : '',
            violationIDs: flaggedIncluded ? form.violationIDs : [],
            usernames: form.usernames.length > 0 ? form.usernames : [],
            workstations: form.workstations.length > 0 ? form.workstations : [],
            includeViolationIDs: [],
            refresh: true
          })
        )

        // Save changes to filter if editing and clicking save and apply
        if (isEditing) {
          handleSaveFilterChanges(form, 'apply')
        }

        props.history.push({
          pathname: '/captures',
          search:
            DefaultView === 'L'
              ? '?view=list&page=1&activeCapture=0'
              : DefaultView === 'G'
                ? '?view=grid&page=1&activeCaptures=[]'
                : '?view=single&capture=1'
        })
        toggleFilterModal()
      }
    }
  }

  // Save currently selected filter to list of MY Filters for the user.
  const handleFilterSave = form => {
    // const selectedStartTime = form.startTime === 0 || form.startTime === '' ? 0 : form.startTime
    // const selectedEndTime = form.endTime === 0 || form.endTime === '' ? 0 : form.endTime

    formatDateTime(form)

    const sourceNum = form.source === 'all' ? 2 : form.source
    const formattedName = form.filterName
      .replace(/[^a-zA-Z0-9-_.: ]/g, '')
      .trim()

    const tempForm = {
      ...filterEditData,
      ...form,
      filterName: formattedName,
      // startTime: selectedStartTime !== 0 ? form.startDate : 0,
      // endTime: selectedEndTime !== 0 ? form.endDate : 0,
      source: sourceNum,
      ...subOptions,
      subStartDate: dateCheck(subOptions.subStartDate, null),
      subEndDate: dateCheck(null, subOptions.subEndDate)
    }

    if (UserFiltersList.find(filter => filter.filterName === formattedName)) {
      setFilterNameError(true)
    } else {
      dispatch(
        createFilter(tempForm, fireFilterSaveSuccess, fireFilterSaveFailure)
      )
    }
  }

  // Set the filterID and form to 'My Filters' on success to display saved filter
  const fireFilterSaveSuccess = filterID => {
    NotificationToast(false, 'Filter Saved Successfully!')
    setSaveFilterModalOpen(false)
    setFilterNameError(false)
    setFilterEditData(defaultFilterEditData)
    dispatch(getUserFilters())
    setFilterForm(FilterFormTypes.MY_FILTERS)
    setOpenFilter(filterID)
  }

  const fireFilterSaveFailure = () => {
    NotificationToast(true, 'Unable to Save Filter.')
  }

  const resetFilter = async () => {
    const resetObj = {
      pathname: '/captures',
      search:
        ActiveView === 'list-view'
          ? '?view=list&page=1&activeCapture=0'
          : ActiveView === 'grid-view'
            ? '?view=grid&page=1&activeCaptures=[]'
            : ActiveView === 'single-view'
              ? '?view=single&capture=1'
              : ActiveView === 'reports'
                ? ''
                : ''
    }

    const pushReset = () => {
      props.history.push(
        ActiveView === 'reports'
          ? '/reports'
          : ActiveView === 'dashboard'
            ? '/dashboard'
            : resetObj
      )
    }

    if (fromLink) {
      const confirmReset = await ConfirmResetToast({
        msg: 'This action will return you to all Captures.',
        txt: 'Do you wish to continue?'
      })
      if (confirmReset) {
        setError(false)
        setTimeError(false)

        dispatch(setFilter(deepDefaultFilter))
        dispatch(setFromLink(false))
        pushReset()
        toggleFilterModal()
      }
    } else {
      setError(false)
      setTimeError(false)
      handleCancelEdit()

      dispatch(setFilter(deepDefaultFilter))
      pushReset()
    }
  }

  const dateCheck = (startDate, endDate) => {
    if (startDate && moment.isMoment(startDate)) {
      if (subOptions.subStartTime) {
        const startMinute = subOptions.subStartTime.minute()
        const startHour = subOptions.subStartTime.hour()

        return startDate
          .startOf('day')
          .add(startHour, 'hour')
          .add(startMinute, 'minute')
          .unix()
      }
      return startDate.startOf('day').unix()
    }

    if (endDate && moment.isMoment(endDate)) {
      return endDate.unix()
    }

    return null
  }

  const onApply = e => {
    handleApply(e, {
      ...newFormData,
      ...subOptions,
      subStartDate: dateCheck(subOptions.subStartDate, null),
      subEndDate: dateCheck(null, subOptions.subEndDate)
    })
  }

  const onSave = e => {
    e.preventDefault()
    if (isEditing) {
      handleSaveFilterChanges(
        {
          ...newFormData,
          ...subOptions,
          subStartDate: dateCheck(subOptions.subStartDate, null),
          subEndDate: dateCheck(null, subOptions.subEndDate)
        },
        'save'
      )
    } else {
      setSaveFilterModalOpen(true)
    }
  }

  // reset just the date and time sections (of the regular filter not the sub filter. Used when sub filter is enabled)
  const resetDatesAndTime = () => {
    setStartDate(null)
    setStartTime(null)
    setEndDate(null)
    setEndTime(null)
    setDateSelectType('range')
    setFormData({
      ...newFormData,
      startTime: '',
      endTime: '',
      startDate: '',
      endDate: ''
    })
  }

  return (
    <div>
      {/* SAVE FILTER DIALOG (START) */}
      <Dialog
        open={saveFilterModalOpen}
        onClose={e => {
          e.preventDefault()
          setSaveFilterModalOpen(false)
          setFilterNameError(false)
        }}
        className='filterModal'
        fullWidth
        maxWidth='sm'
      >
        <DialogTitle disableTypography>
          <Typography
            variant='h4'
            style={{ color: '#3984F7' }}
            className='font-weight-bold'
          >
            Save Filter
          </Typography>
          <IconButton
            aria-label='close'
            className={classes.closeButton}
            onClick={e => {
              e.preventDefault()
              setSaveFilterModalOpen(false)
              setFilterNameError(false)
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Grid
            item
            container
            direction='column'
            xs={12}
            alignItems='center'
            style={{ height: '7rem' }}
          >
            <Grid item container direction='row' justify='flex-start'>
              <Grid item xs={7}>
                <Typography>Name:</Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography style={{ color: '#AFAFAF' }}>
                  {`${newFormData.filterName.length} / 50`}
                </Typography>
              </Grid>
            </Grid>

            <Grid container direction='row' justify='flex-start'>
              <Input
                className={classes.nameInput}
                onChange={e =>
                  setFormData({ ...newFormData, filterName: e.target.value })}
                inputProps={{
                  maxLength: 50
                }}
              />
            </Grid>

            <Grid item container direction='row'>
              <Typography style={{ color: '#AFAFAF', fontSize: '12px' }}>
                Filter name can only contain letters, numbers, dashes,
                underscores, and colons.
              </Typography>
            </Grid>
          </Grid>

          <FilterSubscription
            subOptions={subOptions}
            setSubOptions={setSubOptions}
            subEndSettings={subEndSettings}
            setSubEndSettings={setSubEndSettings}
            isEditing={isEditing}
            subErrCheck={subErrCheck}
            subErrs={subErrs}
            subEndObj={subEndObj}
            subDateErrCheck={subDateErrCheck}
            resetDatesAndTime={resetDatesAndTime}
          />

          <FastFilterToggle
            newFormData={newFormData}
            setFormData={setFormData}
          />
        </DialogContent>

        <DialogActions>
          <Grid item xs={12}>
            {filterNameError && (
              <Grid item container direction='row' justify='flex-end'>
                <Typography
                  variant='caption'
                  style={{
                    color: 'red',
                    marginRight: '1rem',
                    marginBottom: '.5rem'
                  }}
                >
                  *A filter with this name has already been saved. Please try
                  another filter name.
                </Typography>
              </Grid>
            )}
            <Grid item container direction='row' justify='flex-end'>
              <Grid item container xs={5} justify='flex-end'>
                <Button
                  variant='outlined'
                  className={classes.cancelButton}
                  onClick={e => {
                    e.preventDefault()
                    setSaveFilterModalOpen(false)
                    setFilterNameError(false)
                  }}
                  style={{ marginRight: '1rem' }}
                >
                  Cancel
                </Button>

                <Button
                  variant='contained'
                  className={classes.saveBtn}
                  onClick={e => {
                    e.preventDefault()
                    handleFilterSave({ ...newFormData })
                  }}
                  disabled={
                    newFormData.filterName.length === 0 || (subOptions.subEnabled && (subErrCheck || !subOptions.subStartDate || subDateErrCheck))
                  }
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      {/* SAVE FILTER DIALOG (END) */}

      {/* MAIN FILTER DIALOG (START) */}
      <Dialog
        open={open}
        onClose={e => toggleFilterModal(e)}
        className='filterModal'
        fullWidth
        maxWidth='md'
        style={{ maxHeight: '70h' }}
      >
        <DialogTitle disableTypography style={{ paddingBottom: 0 }}>
          <Grid container direction='row'>
            <Grid item xs={6} container direction='row' alignItems='flex-start'>
              <Typography
                variant='h4'
                color='primary'
                classes={{ colorPrimary: classes.greenText }}
                className='font-weight-bold elevio-advanced-filter-title'
              >
                Advanced Filters
              </Typography>
            </Grid>
            <Grid item container xs={5} style={{ justifyContent: 'end' }}>
              <Tabs
                classes={{ root: classes.filterTabs }}
                TabIndicatorProps={{ style: { display: 'none' } }}
                value={filterForm === FilterFormTypes.FILTER_OPTIONS ? 0 : 1}
                style={{ marginRight: '5em', alignItems: 'flex-end' }}
                onChange={e => {
                  handleSwapFilterForms(e)
                }}
              >
                <Tab
                  value={0}
                  classes={
                    filterForm === FilterFormTypes.FILTER_OPTIONS
                      ? { root: classes.activeFilterTab }
                      : { root: classes.inactiveFilterTab }
                  }
                  label='Build Filter'
                  disableRipple
                />

                <Tab
                  value={1}
                  classes={
                    filterForm === FilterFormTypes.MY_FILTERS
                      ? { root: classes.activeFilterTab }
                      : { root: classes.inactiveFilterTab }
                  }
                  label='My Filters'
                  disableRipple
                  className='elevio-my-filter-tab'
                />
              </Tabs>
            </Grid>

            <IconButton
              aria-label='close'
              className={classes.closeButton}
              onClick={e => toggleFilterModal(e)}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </DialogTitle>

        <DialogContent
          dividers
        // style={{ overflow: 'scroll' }}
        >
          <Grid container direction='column'>
            <TabPanel
              index={FilterFormTypes.FILTER_OPTIONS}
              value={filterForm}
            >
              <FilterOptions
                fromLink={fromLink}
                toggleModal={toggleFilterModal}
                errors={{ error, timeError }}
                isEditing={isEditing}
                setIsEditing={setIsEditing}
                filterInfo={{
                  onlyFlagged,
                  dateSelectType,
                  val,
                  stationVal,

                  setVal,
                  setStationVal,
                  setDateSelectType
                }}
                newFormData={newFormData}
                setFormData={setFormData}
                filterForm={filterForm}
                setFilterForm={setFilterForm}
                FilterFormTypes={FilterFormTypes}
                setFilterCheckObject={setFilterCheckObject}
                handleSwapFilterForms={handleSwapFilterForms}
                setFilterEditData={setFilterEditData}
                filterEditData={filterEditData}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                startTime={startTime}
                setStartTime={setStartTime}
                endTime={endTime}
                setEndTime={setEndTime}
                subOptions={subOptions}
                setSubOptions={setSubOptions}
                subEndSettings={subEndSettings}
                setSubEndSettings={setSubEndSettings}
                subErrCheck={subErrCheck}
                subErrs={subErrs}
                subEndObj={subEndObj}
                subDateErrCheck={subDateErrCheck}
                resetDatesAndTime={resetDatesAndTime}
              />
            </TabPanel>

            <TabPanel
              index={FilterFormTypes.MY_FILTERS}
              value={filterForm}
            >
              <UserFilters
                filterForm={filterForm}
                setFilterForm={setFilterForm}
                setFormData={setFormData}
                setSubOptions={setSubOptions}
                setEditedSubOptions={setEditedSubOptions}
                FilterFormTypes={FilterFormTypes}
                isEditing={isEditing}
                setIsEditing={setIsEditing}
                setFilterCheckObject={setFilterCheckObject}
                handleSwapFilterForms={handleSwapFilterForms}
                DefaultView={DefaultView}
                toggleFilterModal={toggleFilterModal}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                setStartTime={setStartTime}
                setEndTime={setEndTime}
                setDateSelectType={setDateSelectType}
                openFilter={openFilter}
                setOpenFilter={setOpenFilter}
                setVal={setVal}
              />
            </TabPanel>
          </Grid>
        </DialogContent>

        {filterForm === FilterFormTypes.FILTER_OPTIONS
          ? (
            <>
              <DialogActions>
                <Grid item container direction='row' justify='flex-end'>
                  <Grid item container xs={7} justify='flex-start'>
                    <Button
                      variant='outlined'
                      className={classes.backBtn}
                      onClick={e => {
                        isEditing && !isEqual(newFormData, filterCheckObject)
                          ? handleResetPopover(e)
                          : resetFilter()
                      }}
                      style={{ marginLeft: '1rem' }}
                    >
                      Reset Filters
                    </Button>
                  </Grid>

                  <Grid item container xs={5} justify='flex-end'>
                    <Button
                      variant='outlined'
                      className={classes.saveFilterBtn}
                      onClick={onSave}
                      style={{ marginRight: '1rem' }}
                      disabled={
                        (isEditing &&
                          isEqual(newFormData, filterCheckObject) &&
                          isEqual(subOptions, editedSubOptions)) ||
                        (isEditing && (subOptions.subEnabled && (subErrCheck || !subOptions.subStartDate || subDateErrCheck)))
                      }
                    >
                      {isEditing ? 'Save Changes' : 'Save to My Filters'}
                    </Button>

                    <Button
                      variant='contained'
                      className={classes.saveBtn}
                      onClick={onApply}
                      disabled={
                        (isEditing &&
                          isEqual(newFormData, filterCheckObject) &&
                          isEqual(subOptions, editedSubOptions)) ||
                        (isEditing && (subOptions.subEnabled && (subErrCheck || !subOptions.subStartDate || subDateErrCheck)))
                      }
                    >
                      {isEditing ? 'Save And Apply' : 'Apply'}
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>
            </>)
          : (
            <></>)}
      </Dialog>
      {/* MAIN FILTER DIALOG (END) */}

      {/* CONFIRMATION POPOVER FOR EDIT (START) */}
      <Popover
        id={openConfirmPopover ? 'confirm-popover' : undefined}
        open={openConfirmPopover}
        anchorEl={confirmAnchorEl}
        onClose={handleConfirmPopClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
      >
        <Grid container direction='column' style={{ padding: '1em' }}>
          <Typography
            style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#3984F7' }}
            gutterBottom
          >
            Filter Updated
          </Typography>

          <Typography
            style={{ fontSize: '.9rem', fontWeight: 'bold' }}
            gutterBottom
          >
            Your saved filter has been updated. Do you want to save your
            changes?
          </Typography>

          <Typography style={{ fontSize: '.9rem' }} gutterBottom>
            You can continue without saving, but your changes will be lost.
          </Typography>

          <Grid
            item
            container
            direction='row'
            justify='flex-end'
            alignItems='center'
            style={{ marginTop: '.5em' }}
          >
            <Button
              onClick={handleConfirmPopClose}
              style={{
                marginRight: '.3em',
                textTransform: 'none',
                fontWeight: '600',
                color: '#98B556'
              }}
            >
              Continue Without Saving
            </Button>

            <Button
              style={{
                textTransform: 'none',
                fontWeight: '600',
                color: '#3984F7'
              }}
              onClick={e => {
                e.preventDefault()
                handleSaveFilterChanges({ ...newFormData }, 'save')
              }}
            >
              Save Changes
            </Button>
          </Grid>
        </Grid>
      </Popover>
      {/* CONFIRMATION POPOVER FOR EDIT (END) */}

      {/* RESET POPOVER (START) */}
      <Popover
        id={openResetPopover ? 'reset-popover' : undefined}
        open={openResetPopover}
        anchorEl={resetAnchorEl}
        onClose={handleResetPopClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
      >
        <Grid container direction='column' style={{ padding: '1em' }}>
          <Typography
            style={{ fontSize: '.9rem', fontWeight: 'bold' }}
            gutterBottom
          >
            This will reset any changes you've made to the current filter.
          </Typography>

          <Typography style={{ fontSize: '.9rem' }} gutterBottom>
            Would you like to continue?
          </Typography>

          <Grid
            item
            container
            direction='row'
            justify='flex-end'
            alignItems='center'
            style={{ marginTop: '.5em' }}
          >
            <Button
              onClick={handleResetPopClose}
              style={{
                marginRight: '.3em',
                textTransform: 'none',
                fontWeight: '600',
                color: '#98B556'
              }}
            >
              Cancel
            </Button>

            <Button
              style={{
                textTransform: 'none',
                fontWeight: '600',
                color: '#3984F7'
              }}
              onClick={e => {
                e.preventDefault()
                handleResetPopClose()
                resetFilter()
              }}
            >
              Confirm
            </Button>
          </Grid>
        </Grid>
      </Popover>
      {/* RESET POPOVER (END) */}

    </div>
  )
}

export default withRouter(FilterSlideout)
